<style lang="scss" scoped>
@import "/src/styles/scss/_variables.scss";
@import "./indicator.scss";
</style>

<template>
  <div
    :class="`slk-g-indicator slk-ind-s-${size} slk-ind-v-${variant} ${indicatorStyle} ${disabled ? 'disabled' : ''}`"
  >
    {{ size != "large" ? "" : counter }}
  </div>
</template>

<script>
export default {
  name: "indicator-view",
  props: {
    size: { type: String, default: "large" },
    variant: { type: String, defaut: "info" },
    indicatorStyle: {
      type: String,
      default: "filled",
    },
    disabled: { type: Boolean, default: false },
    counter: { type: String },
  },
};
</script>
